export enum CompanyType {
  AGENCY = 'Agency',
  BROKER_DEALER = 'Broker/Dealer',
  COMPANY_AFFILIATION = 'Company Affiliation',
}
